import { DialogService, GridAction } from '@eforall/dashboard';
import { PersonDialog, VolunteerDialog } from '../../../../../../../../ui/widget';
import { AcceleratorAreaService } from '../../../../../accelerator-area.service';
import { AccSpecialist } from '../acc-specialists-view.part';

export function getActions(dialogService: DialogService, areaService: AcceleratorAreaService): GridAction<AccSpecialist>[] {

	const actions: GridAction<AccSpecialist>[] = [
		{
			iconClass: 'fa-regular fa-user-tie',
			label: 'View Volunteer Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(VolunteerDialog, { data: { volunteerId: rows[0]!.volunteerId } }, 900, 900);
				await areaService.reloadData(); // if approved languages/topics changed , TODO: reload only if any changes
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Person Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.personId, toEdit: false } }, 800, 800);
			}
		},
	];

	return actions;
}